/**
 * Enum de Siglas de BusinessUnits
 * @enum
 */
export enum BusinessUnitShort {
  BOT = 'BOT',
  EUD = 'EUD',
  OUI = 'OUI',
  EAM = 'EAM',
}

/**
 * Enum de BusinessUnits descritos
 * @enum
 */
export enum BusinessUnitDescribed {
  boticario = 'boticario',
  eudora = 'eudora',
  euamomake = 'euamomake',
  oui = 'oui',
}
